import { type FC, useState } from 'react';
import PickTimePopover from './PickTimePopover';
import PickTimeButton from './PickTimeButton';
import { useAppInsights } from '../../hooks/useAppInsights';
import { getEventFactory } from '../../utils/get-event-factory';
import { Event, type Page, type VesselViewModel } from '../../types';
import { Timestamp } from '../../services/Timestamp';

interface Props {
  isTripsPanelOpen: boolean;
  page: Page;
  operation: string;
  timezone: string;
  vessel: VesselViewModel;
  timestamp: Timestamp;
  setTimestamp: (timestamp: Timestamp) => void;
  setStartTimestamp: (timestamp: Timestamp) => void;
}

const PickTime: FC<Props> = ({
  isTripsPanelOpen,
  page,
  operation,
  vessel,
  timestamp,
  timezone,
  setTimestamp,
  setStartTimestamp,
}): JSX.Element => {
  const [isPickTimeOpen, setIsPickTimeOpen] = useState(false);
  const appInsights = useAppInsights();

  const handleClosePickTime = (): void => {
    const event = getEventFactory(Event.PickTimeClosed)(page, operation, Timestamp.now());
    appInsights.trackAnalyticsEvent(event);
    setIsPickTimeOpen(false);
  };

  const handleOpenPickTime = (): void => {
    const event = getEventFactory(Event.PickTimeOpened)(page, operation, Timestamp.now());
    appInsights.trackAnalyticsEvent(event);
    setIsPickTimeOpen(true);
  };

  return (
    <div>
      <PickTimeButton onOpen={handleOpenPickTime} />
      <PickTimePopover
        isOpen={isPickTimeOpen}
        onClose={handleClosePickTime}
        isTripsPanelOpen={isTripsPanelOpen}
        operation={operation}
        page={page}
        selectedVesselMmsi={vessel?.mmsi}
        timestamp={timestamp}
        timezone={timezone}
        setTimestamp={setTimestamp}
        setStartTimestamp={setStartTimestamp}
      />
    </div>
  );
};

export default PickTime;
